<div class="container-full">
    <div id="centerLogo"></div>
</div>